const ROOT = 'User/editUser/editValues';

export const FETCH_EDIT_USER_REQUEST = `${ROOT}/FETCH_EDIT_USER_REQUEST`;
export const FETCH_EDIT_USER_SUCCESS = `${ROOT}/FETCH_EDIT_USER_SUCCESS`;
export const FETCH_EDIT_USER_FAILURE = `${ROOT}/FETCH_EDIT_USER_FAILURE`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
